export default __webpack_public_path__ + "static/media/back.a73c1b55.svg";